import React from "react"
export const GlobalStateContext = React.createContext()
export const GlobalDispatchContext = React.createContext()
// inital state
const initialState = {
  background: "transparent",
  whiteHeader: false,
}
//! This globalcontextprovider is used to set global state and dispatch TO manage the state of the header. We can use it to manag other global state as well.
// reducer function takes in state and action and updates global state
function reducer(state, action) {
  switch (action.type) {
    case "SET_RESET":
      return initialState
    case "SET_BACKGROUND": {
      return {
        ...state,
        background: action.background,
      }
    }
    case "SET_HEADER": {
      return {
        ...state,
        whiteHeader: action.whiteHeader,
      }
    }
    default:
      throw new Error("bad action type")
  }
}
// global context provider that we use in other components to acess state and dispatch
const GlobalContextProvider = ({ children }) => {
  // make const state and dispatch
  const [state, dispatch] = React.useReducer(reducer, initialState)
  return (
    // wrap providers around children and set values to state and dispatch
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  )
}

export default GlobalContextProvider
